import React, { useEffect } from "react";
import './Pagination.css'; // Import the CSS file
import { CgChevronDoubleLeft, CgChevronLeft, CgChevronRight, CgChevronDoubleRight } from "react-icons/cg";

const Pagination = ({
  gotoPage,
  previousPage,
  nextPage,
  canPreviousPage,
  canNextPage,
  pageCount,
  pageIndex,
  pageOptions,
  pageSize,
  setPageSize,
  totalRecords,
  t,
  DEFAULT_PAGE_SIZE
}) => {
  const handlePageInputChange = (e) => {
    let page = e.target.value ? Number(e.target.value) - 1 : 0;
    if (page < 0) page = 0;
    if (page >= pageCount) page = pageCount - 1;
    gotoPage(page);
  };

  useEffect(() => {
    if (pageIndex >= pageCount) {
      gotoPage(pageCount - 1);
    }
  }, [pageSize, pageCount, pageIndex, gotoPage]);

  return (
    <div className="pagination EnvPagination">
      <div className="pageNumber">
        <button className="ms-0" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          <CgChevronDoubleLeft size={25} />
        </button>
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          <CgChevronLeft size={20} />
        </button>
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          <CgChevronRight size={20} />
        </button>
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          <CgChevronDoubleRight size={25} />
        </button>
        <span className="ms-3">
          {t("page")}&nbsp;
          <span>
            {/* {pageIndex + 1} {t("of")} {pageOptions.length} */}
            {Math.min(pageIndex + 1, pageCount)} {t("of")} {pageCount}
          </span>{" "}
        </span>
      </div>
      <div className="pageSelect text-right">
        <span>
          {t("gotoPage")}:{" "}
          <input
            type="number"
            //value={pageIndex + 1}
            value={Math.min(pageIndex + 1, pageCount)}
            onChange={handlePageInputChange}
            min="1"
            max={pageCount}
          />
        </span>
        <select
          value={pageSize}
          onChange={(e) => setPageSize(Number(e.target.value))}
        >
          {[10, 20, 30, 40, 50,100,500].map((size) => (
            <option key={size} value={size}>
              {t("Show")} {size}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default Pagination;
